import PropTypes from 'prop-types';
import { useTranslation } from '@eti/providers';
import { checkInBaggage } from '@eti/products';
import { constants, string } from '@eti/utils';
import { getBaggageWeightText } from '../../../../widgets/trip-details/utils/format';
import ReviewModalSection from './ReviewModalSection';
import ReviewProductItem from './ReviewProductItem';

const { unicodeControlCharacters } = constants;
const { LRE, PDF } = unicodeControlCharacters;

const ReviewModalIncludedProducts = ({ includedCheckedBaggage }) => {
  const { t } = useTranslation();
  const weightText =
    includedCheckedBaggage && `${LRE}${getBaggageWeightText(includedCheckedBaggage)}${PDF}`;

  return (
    <ReviewModalSection
      subtitle={t('TravelerDetails.Review.Modal.Included.Header.Text')}
      title={t('TravelerDetails.Review.Modal.Included.Header.Label')}
    >
      <ReviewProductItem
        id={checkInBaggage.name}
        title={string.insertArgument(
          t('TravelerDetails.Review.Modal.CheckedInBaggage.Label'),
          weightText,
        )}
      />
    </ReviewModalSection>
  );
};

ReviewModalIncludedProducts.propTypes = {
  includedCheckedBaggage: PropTypes.shape({
    pieces: PropTypes.number,
    weight: PropTypes.number,
    weightUnit: PropTypes.string,
  }),
};

export default ReviewModalIncludedProducts;
